import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Parses a decimal string accepting both Brazilian (1.500,50) and US (1500.50) formats.
 * - Both separators present → "." is thousands, "," is decimal  → remove "." replace "," with "."
 * - Only comma → "," is decimal separator → replace with "."
 * - Only dot  → "." is decimal separator → use as-is
 */
export function parseDecimalBR(s: string | number): number {
  if (typeof s === "number") return isNaN(s) ? 0 : s
  const clean = String(s).replace(/[^0-9.,-]/g, "").trim()
  if (!clean || clean === "-") return 0
  const hasComma = clean.includes(",")
  const hasDot = clean.includes(".")
  let normalized: string
  if (hasComma && hasDot) {
    // Brazilian: 1.500,50 → 1500.50
    normalized = clean.replace(/\./g, "").replace(",", ".")
  } else if (hasComma) {
    // Only comma → decimal: 150,50 → 150.50
    normalized = clean.replace(",", ".")
  } else {
    // Only dot or plain integer
    normalized = clean
  }
  const result = parseFloat(normalized)
  return isNaN(result) ? 0 : result
}

/** Returns the slice of `items` for the current page. */
export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
  return items.slice((page - 1) * pageSize, page * pageSize)
}
